import { render } from "./NewUsers.vue?vue&type=template&id=6159a530&ts=true"
import script from "./NewUsers.vue?vue&type=script&lang=ts"
export * from "./NewUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__